import { PayrollClaimApi } from '../../../api/People/PayrollClaim'
import PayrollClaim from '../../../components/People/PayrollClaim/PayrollClaim'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function PayrollClaimCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => PayrollClaimApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)

  return (
    <PayrollClaim
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

PayrollClaimCont.propTypes = {}
PayrollClaimCont.defaultProps = {}

export default PayrollClaimCont
